import { withErrorBoundary } from "@sentry/nextjs";
import { gql } from "graphql-request";
import { VFC } from "react";
import styled from "styled-components";
import { Markdown } from "components";
import { useAnchor } from "hooks";
import { Carousel2Content } from "types/graphql/generated";
import { Carousel2Desktop, Carousel2Mobile } from "./components";

interface Props {
  content: Carousel2Content;
}

const Carousel2: VFC<Props> = withErrorBoundary(({ content }) => {
  useAnchor("carousel2");

  return (
    <StyledCarousel2 className="carousel2 Content">
      <Carousel2Desktop className="Carousel2__desktopContent" content={content} />
      <Carousel2Mobile className="Carousel2__mobileContent" content={content} />
      <Markdown className="Carousel2__disclaimer Color_tertiary Font_14_20_450 sm:Font_12_16_450">
        {content.disclaimer}
      </Markdown>
    </StyledCarousel2>
  );
}, {});

const StyledCarousel2 = styled.section`
  margin-top: -64px;
  padding-top: 64px;

  .Carousel2__mobileContent {
    display: none;
  }

  .Carousel2__disclaimer {
    margin-top: 48px;
  }

  @media (max-width: ${({ theme }) => `${theme.breakpoints.lg}px`}) {
    .Carousel2__desktopContent {
      display: none;
    }

    .Carousel2__mobileContent {
      display: block;
    }

    .Carousel2__disclaimer {
      margin-top: 32px;
    }
  }
`;

gql`
  fragment Carousel2Content on ComponentCarouselCarousel2 {
    title
    disclaimer
    carousel2Options {
      id
      optionName
      description
      buttonLabel
      buttonLink
      guidelineLogo {
        data {
          guidelineLogo: attributes {
            src: hash
            width
            height
            alt: alternativeText
            ext
          }
        }
      }
      partnerLogos {
        data {
          id
          partnerLogo: attributes {
            src: hash
            width
            height
            alt: alternativeText
            ext
          }
        }
      }
    }
  }
`;

export { Carousel2 };
export type { Props as Carousel2Props };
